// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"44656bef","624":"0049fd53"}[chunkId] + ".chunk.js";
};